<h3 class="common-sub-title">チーム選択</h3>

<dialog-content class="content">
  <table class="common-table h team-table">
    <colgroup>
    <col>
      <col>
        <col>
          <col>
          </colgroup>
          <thead>
            <tr>
              <th>Team Id</th>
              <th>チーム名</th>
              <th>権限</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (team of data.teams; track team) {
              <tr>
                <td>
                  <p>{{team.id}}</p>
                </td>
                <td>
                  <p [class]="getStatusLabelClass(team)">{{team.name}}</p>
                </td>
                <td>
                  <p>{{getAuthName(team)}}</p>
                </td>
                <td>
                  <button class="common-btn-select" (click)="close(team)">選択</button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </dialog-content>

      @if (data.showClose) {
        <button class="common-btn-cancel btn-close" (click)="cancel()">閉じる</button>
      }
